import React, { Component } from "react";
import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBInput,
  MDBBtn,
  MDBCard,
  MDBCardBody,
  MDBIcon
} from "mdbreact";
import axios from "axios";
import API_URL from "./../config";
import logo1 from "./LogoRemuneraciones.png";
import fondo2 from "./Fondo2.jpg";
import fondo3 from "./fondo3.png";

class CambiarContrasena extends Component {
  state = {
    respuesta: [],
    usuario: "",
    claveanterior: "",
    clavenuevo: "",
    mensaje: null,
    tipoMensaje: null,
    showAnterior: false,
    showNueva: false,
    loading: false
  };

  onChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  acceder = async (event) => {
    event.preventDefault();

    if (!this.state.usuario || !this.state.claveanterior || !this.state.clavenuevo) return;

    this.setState({ loading: true });

    try {
      const response = await axios.post(`${API_URL}/cambiarpassword`, {
        method: "post",
        credentials: "same-origin",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          usuario: this.state.usuario,
          claveanterior: this.state.claveanterior,
          clavenuevo: this.state.clavenuevo
        })
      });

      const data = response.data;
      if (data.length > 0) {
        const info = data[0].informacion || "";
        if (data[0].modal1 === "true")
          this.setState({ mensaje: info, tipoMensaje: "exito" });
        else if (data[0].modal2 === "true")
          this.setState({ mensaje: info, tipoMensaje: "error" });
      }
    } catch (err) {
      console.error(err);
    }

    this.setState({ usuario: "", claveanterior: "", clavenuevo: "", loading: false });
  };

  render() {
    const claveValida = this.state.clavenuevo.length >= 8
      && /[a-zA-Z]/.test(this.state.clavenuevo)
      && /[0-9]/.test(this.state.clavenuevo)
      ;
    const formReady = this.state.usuario && this.state.claveanterior && claveValida;

    return (
      <div style={{ position: "relative", minHeight: "calc(100vh - 4rem)" }}>
        {/* Fondo izquierdo */}
        <div
          className="d-none d-md-block"
          style={{
            position: "fixed",
            top: "4rem",
            left: 0,
            width: "25%",
            height: "calc(100vh - 4rem)",
            backgroundImage: `url(${fondo3})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            opacity: 0.15
          }}
        />

        {/* Fondo derecho */}
        <div
          className="d-none d-md-block"
          style={{
            position: "fixed",
            top: "4rem",
            right: 0,
            width: "25%",
            height: "calc(100vh - 4rem)",
            backgroundImage: `url(${fondo2})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            opacity: 0.5
          }}
        />

        <MDBContainer fluid className="pt-4" style={{ position: "relative", zIndex: 1 }}>
          <MDBRow className="justify-content-center align-items-center" style={{ minHeight: "calc(100vh - 6rem)" }}>

            {/* Panel izquierdo informativo */}
            <MDBCol md="3" lg="3" className="d-none d-md-block" style={{ paddingLeft: "40px" }}>
              <h4 className="font-weight-bold mb-3" style={{ color: "#7A1622" }}>
                <MDBIcon icon="user-cog" className="mr-2" />
                Gestión de Cuenta
              </h4>
              <p className="text-muted" style={{ fontSize: "0.95rem", lineHeight: "1.6" }}>
                Desde aquí puede cambiar su contraseña de acceso al sistema de remuneraciones.
              </p>

              <h6 className="font-weight-bold mt-4 mb-3" style={{ color: "#333" }}>
                Recomendaciones de seguridad
              </h6>

              <div className="mb-3 d-flex align-items-start">
                <MDBIcon icon="shield-alt" className="mr-3 mt-1" style={{ color: "#7A1622", fontSize: "1.1rem" }} />
                <div>
                  <strong style={{ color: "#333" }}>Contraseña segura</strong>
                  <p className="text-muted mb-0" style={{ fontSize: "0.85rem" }}>
                    Use al menos 8 caracteres combinando letras y números.
                  </p>
                </div>
              </div>

              <div className="mb-3 d-flex align-items-start">
                <MDBIcon icon="lock" className="mr-3 mt-1" style={{ color: "#7A1622", fontSize: "1.1rem" }} />
                <div>
                  <strong style={{ color: "#333" }}>No comparta su clave</strong>
                  <p className="text-muted mb-0" style={{ fontSize: "0.85rem" }}>
                    Su contraseña es personal e intransferible.
                  </p>
                </div>
              </div>

              <div className="mb-3 d-flex align-items-start">
                <MDBIcon icon="sync-alt" className="mr-3 mt-1" style={{ color: "#7A1622", fontSize: "1.1rem" }} />
                <div>
                  <strong style={{ color: "#333" }}>Cambio periódico</strong>
                  <p className="text-muted mb-0" style={{ fontSize: "0.85rem" }}>
                    Se recomienda cambiar su contraseña cada cierto tiempo.
                  </p>
                </div>
              </div>

              <hr />

              <h6 className="font-weight-bold mb-3" style={{ color: "#333" }}>
                <MDBIcon icon="headset" className="mr-2" style={{ color: "#7A1622" }} />
                Contacto
              </h6>
              <p className="text-muted mb-0" style={{ fontSize: "0.85rem" }}>
                <MDBIcon icon="envelope" className="mr-2" style={{ color: "#7A1622" }} />
                remuneraciones@unsaac.edu.pe
              </p>
            </MDBCol>

            {/* Card central */}
            <MDBCol md="5" lg="4" className="d-flex justify-content-center">
              <MDBCard style={{ width: "100%", maxWidth: "420px", position: "relative" }}>
                <MDBCardBody className="px-4 py-4">
                  <div className="text-center mb-4">
                    <p className="text-muted mb-2" style={{ fontSize: "0.9rem" }}>
                      Universidad Nacional de San Antonio Abad del Cusco
                    </p>
                    <img
                      src={logo1}
                      alt="Logo Remuneraciones"
                      style={{ width: "130px", height: "130px", objectFit: "contain", borderRadius: "50%" }}
                    />
                    <h6 className="mt-2 font-weight-bold" style={{ color: "#7A1622" }}>
                      Sub Unidad de Remuneraciones
                    </h6>
                    <h4 className="font-weight-bold" style={{ color: "#7A1622", fontSize: "1.5rem" }}>
                      <MDBIcon icon="key" className="mr-2" />
                      Cambiar Contraseña
                    </h4>
                  </div>

                  <hr />

                  {this.state.mensaje && (
                    <div style={{
                      backgroundColor: this.state.tipoMensaje === "exito" ? "#d4edda" : "#f8d7da",
                      color: this.state.tipoMensaje === "exito" ? "#155724" : "#721c24",
                      border: `1px solid ${this.state.tipoMensaje === "exito" ? "#c3e6cb" : "#f5c6cb"}`,
                      borderRadius: "10px",
                      padding: "14px 16px",
                      marginBottom: "16px",
                      display: "flex",
                      alignItems: "center",
                      animation: "fadeIn 0.3s ease"
                    }}>
                      <MDBIcon
                        icon={this.state.tipoMensaje === "exito" ? "check-circle" : "exclamation-triangle"}
                        className="mr-3"
                        style={{ fontSize: "1.5rem" }}
                      />
                      <div style={{ flex: 1 }}>
                        <strong style={{ fontSize: "0.9rem" }}>
                          {this.state.tipoMensaje === "exito" ? "¡Contraseña actualizada!" : "No se pudo cambiar"}
                        </strong>
                        <p style={{ margin: "4px 0 0", fontSize: "0.83rem" }}>{this.state.mensaje}</p>
                      </div>
                      <MDBIcon
                        icon="times"
                        style={{ cursor: "pointer", fontSize: "1rem", opacity: 0.6 }}
                        onClick={() => this.setState({ mensaje: null, tipoMensaje: null })}
                      />
                    </div>
                  )}

                  <form onSubmit={this.acceder}>
                    <MDBInput
                      label="Número de DNI"
                      icon="user"
                      group
                      validate
                      value={this.state.usuario}
                      onChange={this.onChange.bind(this)}
                      name="usuario"
                      id="usuario"
                      type="text"
                    />

                    <div style={{ position: "relative" }}>
                      <MDBInput
                        label="Contraseña anterior"
                        icon="lock"
                        group
                        validate
                        value={this.state.claveanterior}
                        onChange={this.onChange.bind(this)}
                        name="claveanterior"
                        id="claveanterior"
                        type={this.state.showAnterior ? "text" : "password"}
                      />
                      <MDBIcon
                        icon={this.state.showAnterior ? "eye-slash" : "eye"}
                        onClick={() => this.setState({ showAnterior: !this.state.showAnterior })}
                        style={{
                          position: "absolute",
                          right: "10px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          cursor: "pointer",
                          color: "#999"
                        }}
                      />
                    </div>

                    <div style={{ position: "relative" }}>
                      <MDBInput
                        label="Contraseña nueva"
                        icon="lock"
                        group
                        validate
                        value={this.state.clavenuevo}
                        onChange={this.onChange.bind(this)}
                        name="clavenuevo"
                        id="clavenuevo"
                        type={this.state.showNueva ? "text" : "password"}
                      />
                      <MDBIcon
                        icon={this.state.showNueva ? "eye-slash" : "eye"}
                        onClick={() => this.setState({ showNueva: !this.state.showNueva })}
                        style={{
                          position: "absolute",
                          right: "10px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          cursor: "pointer",
                          color: "#999"
                        }}
                      />
                    </div>

                    {this.state.clavenuevo.length > 0 && (
                      <div style={{
                        backgroundColor: "#f8f9fa",
                        borderRadius: "8px",
                        padding: "10px 14px",
                        marginBottom: "16px",
                        border: "1px solid #e0e0e0"
                      }}>
                        <p style={{ margin: "0 0 6px", fontSize: "0.82rem", fontWeight: "600", color: "#333" }}>Requisitos de contraseña:</p>
                        {[
                          { ok: this.state.clavenuevo.length >= 8, text: "Mínimo 8 caracteres" },
                          { ok: /[a-zA-Z]/.test(this.state.clavenuevo), text: "Al menos una letra" },
                          { ok: /[0-9]/.test(this.state.clavenuevo), text: "Al menos un número" },
                          
                        ].map((req, i) => (
                          <p key={i} style={{ margin: "2px 0", fontSize: "0.8rem" }}>
                            <MDBIcon
                              icon={req.ok ? "check-circle" : "times-circle"}
                              className="mr-2"
                              style={{ color: req.ok ? "#27ae60" : "#c0392b" }}
                            />
                            <span style={{ color: req.ok ? "#27ae60" : "#666" }}>{req.text}</span>
                          </p>
                        ))}
                      </div>
                    )}

                    <div className="text-center mt-3">
                      <MDBBtn
                        type="submit"
                        style={{
                          backgroundColor: formReady && !this.state.loading ? "#7A1622" : "#999",
                          borderRadius: "20px"
                        }}
                        className="btn-block"
                        disabled={!formReady || this.state.loading}
                      >
                        {this.state.loading ? (
                          <span><MDBIcon icon="spinner" spin className="mr-2" />Cambiando contraseña...</span>
                        ) : (
                          <span><MDBIcon icon="key" className="mr-2" />Cambiar Contraseña</span>
                        )}
                      </MDBBtn>
                    </div>
                  </form>

                  {/* Overlay de carga */}
                  {this.state.loading && (
                    <div style={{
                      position: 'absolute', top: 0, left: 0, right: 0, bottom: 0,
                      backgroundColor: 'rgba(255,255,255,0.85)',
                      borderRadius: '8px',
                      display: 'flex', flexDirection: 'column',
                      alignItems: 'center', justifyContent: 'center',
                      zIndex: 10
                    }}>
                      <MDBIcon icon="spinner" spin style={{ fontSize: '2.5rem', color: '#7A1622', marginBottom: '12px' }} />
                      <p style={{ color: '#7A1622', fontWeight: '600', fontSize: '1rem', margin: 0 }}>Cambiando contraseña...</p>
                      <p style={{ color: '#888', fontSize: '0.82rem', margin: '4px 0 0' }}>Por favor espere</p>
                    </div>
                  )}
                </MDBCardBody>
              </MDBCard>
            </MDBCol>

            <MDBCol md="3" lg="3" className="d-none d-md-block" />
          </MDBRow>
        </MDBContainer>


      </div>
    );
  }
}

export default CambiarContrasena;
